import { useNavigate } from 'react-router-dom';
import BackButtonHeader from '../components/Navigation/BackButtonHeader';

const HubspotCompaniesIframe = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col h-screen">
            {/* Navigation Header */}
            <div className='bg-lime-green pr-6'>
                <BackButtonHeader navigateBack={() => navigate('/')} name='Home'/>
            </div>

            {/* Iframe */}
            <iframe
                src="https://cai-hubspot-ui-extension-test.vercel.app"
                title="HubSpot CRM"
                className="w-full flex-1 border-none"
            />
        </div>
    );
};

export default HubspotCompaniesIframe;